import { Menu } from "../menu/menu";
import { MenuButton } from "../menu-button";
import { BackButton } from "../back-button";

import styles from "./header.module.css";

export function Header({ isHome }) {
  return (
    <header className={`${styles.header}${isHome ? ` ${styles.home}` : ""}`}>
      {!isHome ? <BackButton /> : null}
      {isHome ? <h1>Amanda Onnela</h1> : null}
      <Menu isHome={isHome} />
      <MenuButton />
    </header>
  );
}
